import { useUserProfileContext } from "@context/user_profile";
import { Navigate } from "react-router";
import EmployerDashboardPage from "@page/employer-dashboard";
import JobSeekerJobMatche from "@page/job-seeker-dashboard/job-matches";
import AgentDashboardPage from "@page/agent-dashboard";
import TrainingDashboardPage from "@page/training-dashboard";
import DriveThruDemoPage from "@page/drive-thru-demo";
import { isOuraEnabled } from "@oura/role";

export default function DashboardPage() {
    const [isLoadingUserProfile, userInfo] = useUserProfileContext();

    if (isLoadingUserProfile) return <></>
    if (!userInfo) return <Navigate to="/" />

    if (userInfo.role === "hr" || userInfo.role === "admin" || userInfo.role === "super_admin") {
        return <EmployerDashboardPage />
    } else if (userInfo.role === "job_seeker") {
        return <JobSeekerJobMatche />
    } else if (userInfo.role === "agent") {
        return <AgentDashboardPage />
    } else if (userInfo.role == "training-agent") {
        return <TrainingDashboardPage />
    } else if (userInfo.role === "oura-staff" || userInfo.role === "oura-client") {
        // Oura roles never render a dashboard here — they live entirely under
        // /oura, whose index redirects staff to the pipeline and clients to
        // their own business dashboard.
        //
        // With the product switched off in production there is nowhere to send
        // them: an Oura role grants access to Oura and nothing else, so falling
        // through to a recruiter dashboard would show them someone else's
        // product. /unauthorized is the honest answer, and it terminates —
        // bouncing back to /oura would loop against that route's own guard.
        return <Navigate to={isOuraEnabled() ? "/oura" : "/unauthorized"} />
    } else if (userInfo.company_type === "drive-thru" || userInfo.role === "drive-thru") {
        // Drive-thru demo workspaces (Tealive / Bask Bear) get the POS-screen
        // UI instead of a recruiter dashboard. The BE marks them with BOTH
        // role and company_type == "drive-thru"; company_type is the routing
        // key per the contract. Every /drive-thru endpoint 403s for anyone
        // else, so this is a display route, not the security boundary.
        return <DriveThruDemoPage />
    }

    return <Navigate to="/unauthorized" />
}